/* Feedback for normal page navigation, without delaying links or form actions. */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a.button, .blog-filter-list a');
  if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
  const destination = new URL(link.href, location.href);
  if (destination.origin !== location.origin || (destination.pathname === location.pathname && destination.search === location.search)) return;
  document.documentElement.classList.add('unism-navigating');
  window.setTimeout(() => document.documentElement.classList.remove('unism-navigating'), 8000);
});
window.addEventListener('pageshow', () => document.documentElement.classList.remove('unism-navigating'));
/* Keep mobile drawer controls aligned with the header. */
function setupUnismMobileControls() {
  const opener = document.querySelector('button[aria-controls="header-sidebar-menu"]');
  const burgerMarkup = '<span class="unism-burger" aria-hidden="true"><i></i><i></i><i></i></span>';
  if (opener && !opener.querySelector('.unism-burger')) {
    opener.querySelector('svg')?.remove();
    opener.insertAdjacentHTML('beforeend', burgerMarkup);
  }
  const logo = document.querySelector('.header__logo-image');
  const facets = document.getElementById('facets-drawer');
  if (facets && logo && !facets.querySelector('.unism-mobile-drawer-brand')) {
    const brand = document.createElement('div');
    brand.className = 'unism-mobile-drawer-brand';
    brand.slot = 'header';
    brand.append(logo.cloneNode(true));
    facets.append(brand);
  }
  for (const drawer of document.querySelectorAll('#header-sidebar-menu,#facets-drawer')) {
    const close = drawer.shadowRoot?.querySelector('[part="close-button"]');
    if (close && !close.querySelector('.unism-burger')) {
      close.innerHTML = burgerMarkup;
      const style = document.createElement('style');
      style.textContent = '@media(max-width:999px){.unism-burger{display:block;position:relative;width:22px;height:18px}.unism-burger i{position:absolute;left:0;top:8px;width:22px;height:1.5px;background:#4b3a33;transition:transform .22s,opacity .22s}.unism-burger i:first-child{transform:rotate(45deg)}.unism-burger i:nth-child(2){opacity:0}.unism-burger i:last-child{transform:rotate(-45deg)}}@media(min-width:1000px){.unism-burger{display:block;width:16px;height:16px;position:relative}.unism-burger:before,.unism-burger:after{content:"";position:absolute;top:7px;left:0;width:16px;height:1px;background:currentColor;transform:rotate(45deg)}.unism-burger:after{transform:rotate(-45deg)}}';
      style.textContent += '@media(max-width:999px) and (prefers-reduced-motion:no-preference){:host([open]) .unism-burger i:first-child{animation:unism-close-top .24s ease-out}:host([open]) .unism-burger i:last-child{animation:unism-close-bottom .24s ease-out}@keyframes unism-close-top{from{transform:translateY(-6px) rotate(0)}to{transform:rotate(45deg)}}@keyframes unism-close-bottom{from{transform:translateY(6px) rotate(0)}to{transform:rotate(-45deg)}}}';
      drawer.shadowRoot.append(style);
    }
  }
}
setupUnismMobileControls();
document.addEventListener('shopify:section:load', setupUnismMobileControls);
/* Animate the nested mobile lists without changing desktop disclosures. */
document.addEventListener('click', (event) => {
  const summary = event.target.closest?.('.unism-mobile-category > summary');
  if (!summary) return;
  const details = summary.parentElement;
  const content = details.querySelector('.unism-mobile-category-links');
  if (!content || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  event.preventDefault();
  if (details.dataset.animating) return;
  details.dataset.animating = 'true';
  const closing = details.open;
  if (!closing) details.open = true;
  const height = content.getBoundingClientRect().height;
  content.style.overflow = 'hidden';
  content.animate({height: closing ? [height+'px','0px'] : ['0px',height+'px'], opacity: closing ? [1,0] : [0,1]}, {duration: 180,easing: 'ease-out'}).finished.then(() => {
    if (closing) details.open = false;
    content.style.overflow = '';
    delete details.dataset.animating;
  });
});

/* One set of screen coordinates for the header and both mobile drawers. */
window.unismAlignMobileDrawers = function () {
  if (!matchMedia('(max-width:999px)').matches) return;
  const header = document.querySelector('store-header');
  const logo = header?.querySelector('.header__logo-image');
  const burger = header?.querySelector('.unism-burger');
  if (!logo || !burger) return;
  const h = header.getBoundingClientRect();
  const l = logo.getBoundingClientRect();
  const b = burger.getBoundingClientRect();
  const values = {'header-bottom': h.bottom, 'logo-left': l.left, 'logo-top': l.top, 'logo-width': l.width, 'logo-height': l.height, 'burger-left': b.left, 'burger-top': b.top};
  for (const [key,value] of Object.entries(values)) document.documentElement.style.setProperty('--unism-'+key, value+'px');
};
window.unismAlignMobileDrawers();
window.addEventListener('resize', window.unismAlignMobileDrawers);
if (document.querySelector('store-header')) new ResizeObserver(window.unismAlignMobileDrawers).observe(document.querySelector('store-header'));

function setupUnismLogoRibbons() {
  document.querySelectorAll('.unism-logo-marquee:not([data-ready])').forEach(ribbon => {
    ribbon.dataset.ready = 'true';
    const track = ribbon.querySelector('.unism-logo-track');
    const group = track.firstElementChild;
    const copy = group.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.setAttribute('inert', '');
    copy.querySelectorAll('[data-shopify-editor-block], [id]').forEach(el => {
      el.removeAttribute('data-shopify-editor-block'); el.removeAttribute('id');
    });
    track.append(copy);
    const images = [...track.querySelectorAll('img')];
    images.forEach(img => { img.loading = 'eager'; });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const speed = 28.6;
    let animation, distance = 0, visible = false, decoded = false;
    const sync = () => {
      if (!animation) return;
      if (reduced.matches || !visible || ribbon.matches(':focus-within')) animation.pause();
      else animation.play();
    };
    const measure = () => {
      if (!decoded) return;
      const width = group.getBoundingClientRect().width;
      if (reduced.matches) { animation?.cancel(); animation = null; distance = 0; return; }
      if (!width || Math.abs(width - distance) < .1) { sync(); return; }
      const offset = animation ? ((Number(animation.currentTime) || 0) * speed / 1000) % distance : 0;
      animation?.cancel(); distance = width;
      animation = track.animate([
        {transform:'translate3d(0,0,0)'},
        {transform:`translate3d(${-distance}px,0,0)`}
      ], {duration:distance / speed * 1000, iterations:Infinity, easing:'linear'});
      animation.currentTime = (offset % distance) / speed * 1000;
      sync();
    };
    const resize = new ResizeObserver(measure); resize.observe(group);
    const visibility = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
    visibility.observe(ribbon);
    ribbon.addEventListener('focusin', sync);
    ribbon.addEventListener('focusout', () => requestAnimationFrame(sync));
    reduced.addEventListener('change', measure);
    let disposed = false;
    Promise.all(images.map(img => img.decode().catch(() => {}))).then(() => {
      if (!disposed) { decoded = true; measure(); }
    });
    const unload = event => {
      if (!event.target.contains(ribbon)) return;
      disposed = true; animation?.cancel(); resize.disconnect(); visibility.disconnect();
      reduced.removeEventListener('change', measure);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  });
}
setupUnismLogoRibbons();
document.addEventListener('shopify:section:load', setupUnismLogoRibbons);
/* Finish images use Shopify's native collection facets and shared update flow. */
document.addEventListener('click', event => {
 const link = event.target.closest?.('[data-unism-finish-link]');
 if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
 const collectionSection = document.querySelector('.shopify-section--main-collection');
 if (!collectionSection) return;
 event.preventDefault();
 const url = new URL(link.href);
 url.searchParams.delete('page');
 url.searchParams.set('section_id', collectionSection.id.replace('shopify-section-', ''));
 link.dispatchEvent(new CustomEvent('facet:update', {bubbles:true, detail:{url}}));
});
document.addEventListener('keydown', event => {
 if (event.key === ' ' && event.target.matches?.('[data-unism-finish-link][role="button"]')) {
  event.preventDefault(); event.target.click();
 }
});
